'use client';
import { useEffect, useState } from 'react';
import { signOut } from 'next-auth/react';
import { useToast } from '@eqi-investimentos/react';
import { getFeatureFlag } from '@/libs/firebase/firebaseConfig';
import { useT } from '@/libs/i18n/utils/useT';
import { toastConfigDefault } from '@/utils/toast';

export const useMaintenance = () => {
  const i18n = useT();

  const toast = useToast(toastConfigDefault.error);

  const messagesTypes = generateMessagesTypes(i18n);

  const [isOutOfService, setIsOutOfService] = useState<boolean>(false);
  const [hasUnstable, setHasUnstable] = useState<boolean>(false);
  const [isVisible, setIsVisible] = useState<boolean>(false);

  const [message, setMessage] = useState<{
    title?: string;
    description: string;
  } | null>(null);

  const messagePosition = isOutOfService
    ? messagesTypes.maintenance
    : messagesTypes.unstable;

  useEffect(() => {
    checkConnectionUnstable();
    getConfigs();

    window.addEventListener(MAINTENANCE_CHECK_STATE_EVENT, checkStatusFlag);

    return () => {
      window.removeEventListener(
        MAINTENANCE_CHECK_STATE_EVENT,
        checkStatusFlag
      );
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isOutOfService && !hasUnstable) {
      signOut();
      handleSetMessage();
    }

    if (hasUnstable && !isOutOfService) {
      handleSetMessage(12000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOutOfService, hasUnstable]);

  const handleSetMessage = (timeOut = 800) => {
    setTimeout(() => {
      setMessage(messagePosition);
      setIsVisible(true);
    }, timeOut);
  };

  const checkStatusFlag = async (event: Event) => {
    const customEvent = event as CustomEvent<{ flag: string }>;
    const { flag } = customEvent.detail;
    const valIsOutOfService = await getFeatureFlag('isOutOfService');
    if (flag === 'isOutOfService' && !!valIsOutOfService) {
      setIsVisible(true);
      setMessage(messagesTypes.maintenance);
    }
  };

  const getConfigs = async () => {
    const valIsOutOfService = await getFeatureFlag('isOutOfService');
    setIsOutOfService(valIsOutOfService);
    const valHasUnstable = await getFeatureFlag('hasUnstable');
    setHasUnstable(valHasUnstable);
  };

  const checkConnectionUnstable = () => {
    if (!navigator.onLine) {
      toast({
        description:
          'Sua conexão com a internet está instável. Verifique e tente novamente',
      });
    }
  };

  const dismssDisclaimer = () => {
    setIsVisible(false);
  };

  return {
    isVisible,
    message,
    dismssDisclaimer,
  };
};

export const MAINTENANCE_CHECK_STATE_EVENT = 'maintenance_check_state';

const generateMessagesTypes = (i18n: (key: string) => string) => {
  return {
    unstable: {
      description: i18n('maintenance.unstable.description'),
    },
    maintenance: {
      title: i18n('maintenance.maintenance.title'),
      description: i18n('maintenance.maintenance.description'),
    },
  };
};
